var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 6.75V1.21125C0.5 0.86625 0.61575 0.57825 0.84725 0.34725C1.07825 0.11575 1.36625 0 1.71125 0H5.75V6.75H0.5ZM7.25 0H11.2887C11.6337 0 11.9218 0.11575 12.1528 0.34725C12.3843 0.57825 12.5 0.868 12.5 1.2165V3.75H7.25V0ZM7.25 12V5.25H12.5V10.7887C12.5 11.1337 12.3845 11.4218 12.1535 11.6528C11.922 11.8843 11.6337 12 11.2887 12H7.25ZM0.5 8.25H5.75V12H1.71125C1.36625 12 1.07825 11.8845 0.84725 11.6535C0.61575 11.422 0.5 11.132 0.5 10.7835V8.25Z",
    fill: "url(#paint0_linear_23_100)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_100",
    x1: 0.592784,
    y1: 6.21818,
    x2: 12.3918,
    y2: 6.21818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43FFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CE87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.f41c831b1c5615d75705831d85185981.svg";
export { ForwardRef as ReactComponent };